module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow-form form-wrapper",
    on: {
      "change": _vm.setDirty
    }
  }, [(_vm.flow.isWithError()) ? _c('div', {
    staticClass: "actions-errors error-message"
  }, [_c('div', {
    staticClass: "action-errors"
  }, [_vm._v(_vm._s(_vm.$t('general.feedback.unknownError')) + "  "), _c('a', {
    staticClass: "retry-link",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.retry')))])])]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(Object.keys(_vm.all_errors).length) ? _c('div', {
    staticClass: "actions-errors error-message"
  }, [_c('div', {
    staticClass: "error-header"
  }, [_vm._v(_vm._s(_vm.$t('flows.feedback.unknownError')))]), _vm._l((_vm.all_errors), function(error, key) {
    return _c('div', {
      staticClass: "action-errors"
    }, [_vm._v("- " + _vm._s(error))])
  })], 2) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-7"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.name')))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.flow.name),
      expression: "flow.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.flow.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.flow, "name", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    key: "name",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1), _c('div', [_c('div', {
    staticClass: "flow-type-toggler-wrapper"
  }, [_c('div', {
    staticClass: "toggler-inline flow-type-toggle",
    on: {
      "click": function($event) {
        return _vm.toggleType()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.flow.semi_automatic
    }
  }), _c('label', [_vm._v(_vm._s(_vm.flow_type_label))])])])]), _c('hr'), _c('div', [_c('div', {
    staticClass: "flow-category-dropdown"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('category')
    }
  }, [_c('label', {
    attrs: {
      "for": "category"
    }
  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.category')))]), _c('dropdown-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field",
    attrs: {
      "name": "category",
      "options": _vm.flow_categories
    },
    on: {
      "input": function($event) {
        return _vm.onCategoryChange($event)
      }
    },
    model: {
      value: (_vm.flow.category_id),
      callback: function($$v) {
        _vm.$set(_vm.flow, "category_id", $$v)
      },
      expression: "flow.category_id"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('category')),
      expression: "errors.has('category')"
    }],
    key: "category",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('category')))])])], 1)])]), _c('hr'), (_vm.flow.category_id == 3) ? _c('div', [_c('div', [_c('div', {
    staticClass: "flow-task-execution-timer"
  }, [_c('div', {
    staticClass: "flow-task-execution-timer-toggle",
    on: {
      "click": function($event) {
        return _vm.toggleTaskTimer()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.isReevAccount
    },
    domProps: {
      "checked": _vm.flow.with_task_timer
    }
  }), _c('div', [_c('label', [_c('b', {
    staticClass: "with-task-timer-title"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.withTaskTimerTitle')))]), _c('div', {
    staticClass: "with-task-timer-label"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.withTaskTimerLabel')))])])])])])]), _c('hr')]) : _vm._e(), _c('div', [_c('div', {
    staticClass: "checkbox-inline",
    attrs: {
      "id": "toggle-has-email-per-day"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleHasEmailsPerDay()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.has_emails_per_day
    }
  }), _c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.hasEmailsPerDay')))])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.has_emails_per_day) ? _c('div', {
    staticClass: "form-group flow-emails-per-day pull-right no-margin-bottom",
    class: {
      'has-error': _vm.errors.has('emails_per_day')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flow.emails_per_day),
      expression: "flow.emails_per_day"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.has_emails_per_day,
          between: [1, 1000]
        }
      }),
      expression: "{ rules: { required: has_emails_per_day, between: [1,1000] } }"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "emails-per-day",
      "type": "text",
      "name": "emails_per_day"
    },
    domProps: {
      "value": (_vm.flow.emails_per_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.flow, "emails_per_day", $event.target.value)
      }
    }
  }), _c('div', {
    staticClass: "input-group-addon light-text"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.contactsPerDay')))])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errors.has('emails_per_day')) ? _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('general.label.numberIntervalLimit', {
    min: 1,
    max: 1000
  })))]) : _vm._e()])], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "clear"
  }), _c('hr'), _c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('flows.label.executeTasks')))]), _c('div', {
    staticClass: "flow-weekday-checkboxes-wrapper",
    class: {
      'has-error': _vm.errors.has('weekdays_to_send')
    }
  }, _vm._l((_vm.weekdays), function(weekday_name, weekday_number) {
    return _c('div', {
      staticClass: "checkbox-inline flow-weekday-checkbox-item",
      on: {
        "click": function($event) {
          return _vm.toggleWeekday(weekday_number)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "checkbox",
        "name": "weekdays_to_send"
      },
      domProps: {
        "checked": _vm.weekdaySelected(weekday_number)
      }
    }), _c('label', [_vm._v(_vm._s(weekday_name))])])
  }), 0), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errors.has('weekdays_to_send')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.$t('general.label.requiredDateField')))]) : _vm._e()])], 1), (_vm.flow.isNew() || _vm.flow.isWithError()) ? _c('fieldset', {
    staticClass: "borderless"
  }, [_c('hr'), _c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.flow.toggleStatus()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.flow.isPublished()
    }
  }), _c('label', {
    staticClass: "no-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('flows.actions.activateAfterCreate')))])])])]) : _vm._e()])]), _c('hr', {
    staticClass: "thick flow-actions"
  }), _c('h2', [_vm._v(_vm._s(_vm.$t('flows.title.actions')))]), _c('div', {
    staticClass: "titleized"
  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.actions')))]), _c('action-picker'), _c('hr', {
    staticClass: "thick"
  }), _c('div', {
    staticClass: "flow-form__lost"
  }, [_c('div', {
    staticClass: "flow-form__lost-selects"
  }, [_c('div', {
    staticClass: "flow-form__lost-select"
  }, [_c('h2', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.$t('flows.title.markAsLost')))]), _c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('div', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flow.set_lost_on_finish),
      expression: "flow.set_lost_on_finish"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkStageLost",
      "disabled": _vm.disabledStageLost
    },
    domProps: {
      "checked": Array.isArray(_vm.flow.set_lost_on_finish) ? _vm._i(_vm.flow.set_lost_on_finish, null) > -1 : (_vm.flow.set_lost_on_finish)
    },
    on: {
      "click": function($event) {
        return _vm.checkStage()
      },
      "change": function($event) {
        var $$a = _vm.flow.set_lost_on_finish,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.flow, "set_lost_on_finish", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.flow, "set_lost_on_finish", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.flow, "set_lost_on_finish", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "checkStageLost"
    }
  }, [_vm._v(_vm._s(_vm.$t('flows.label.markAsLostIfNoReply')))])])]), _c('div', {
    staticClass: "lost_reason_selection"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.checkReasonForLoss')))]), _c('div', {
    staticClass: "delay-inputs-wrapper"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('lost_reason_id')
    }
  }, [_c('dropdown-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field",
    attrs: {
      "name": "lost_reason_id",
      "disabled": !_vm.flow.set_lost_on_finish,
      "options": _vm.lostReasonOptions(_vm.flow.lost_reason_id)
    },
    model: {
      value: (_vm.flow.lost_reason_id),
      callback: function($$v) {
        _vm.$set(_vm.flow, "lost_reason_id", $$v)
      },
      expression: "flow.lost_reason_id"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lost_reason_id')),
      expression: "errors.has('lost_reason_id')"
    }],
    key: "lost_reason_id",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('lost_reason_id')))])])], 1)])]), _c('div', {
    staticClass: "flow-form__lost-select"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('flows.title.endContacts')) + " ")]), _c('div', {
    staticClass: "titleized"
  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.endContacts')))]), _c('div', {
    staticClass: "delay-inputs-wrapper form-inline"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('delay_before_finishing_contact_amount')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flow.delay_before_finishing_contact_amount),
      expression: "flow.delay_before_finishing_contact_amount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|between:0,300'),
      expression: "'required|between:0,300'"
    }],
    staticClass: "form-control delay-before-finishing-contact-amount text-center",
    attrs: {
      "type": "text",
      "name": "delay_before_finishing_contact_amount"
    },
    domProps: {
      "value": (_vm.flow.delay_before_finishing_contact_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.flow, "delay_before_finishing_contact_amount", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('delay_before_finishing_contact_unit')
    }
  }, [_c('dropdown-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field delay-before-finishing-contact-unit",
    attrs: {
      "name": "delay_before_finishing_contact_unit",
      "options": _vm.delay_before_finishing_contact_options
    },
    model: {
      value: (_vm.flow.delay_before_finishing_contact_unit),
      callback: function($$v) {
        _vm.$set(_vm.flow, "delay_before_finishing_contact_unit", $$v)
      },
      expression: "flow.delay_before_finishing_contact_unit"
    }
  })], 1)])])]), (false) ? _c('div', {
    staticClass: "flow-form__lost-switch"
  }, [_c('div', {
    staticClass: "titleized"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.checkIfSendToFlow')) + "  "), _c('span', {
    staticClass: "glyphicon glyphicon-question-sign",
    attrs: {
      "id": "perda-tooltip",
      "data-toggle": "tooltip",
      "title": _vm.$t('flows.label.labelAboutFlow'),
      "data-placement": "right"
    }
  })]), _c('div', {
    staticClass: "toggler-inline"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sent_to_flow
    }
  }), _c('label', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.switchSendToFlow()
      }
    }
  }, [_vm._v(_vm._s(_vm.sent_to_flow ? _vm.$t('general.label.yes') : _vm.$t('general.label.no')))]), (_vm.sent_to_flow) ? _c('flows', {
    attrs: {
      "user_id": _vm.selected_user
    },
    on: {
      "flow-selected": _vm.selectFlow
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _c('hr', {
    staticClass: "tick"
  }), _c('contacts-form', {
    ref: "contacts_form",
    attrs: {
      "flow": _vm.flow
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('flows.title.BCC')))]), _c('div', {
    staticClass: "titleized"
  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.BCC')))]), _c('div', {
    staticClass: "checkbox-inline flow-bcc-checkbox-item",
    on: {
      "click": function($event) {
        _vm.flow.bcc = !_vm.flow.bcc
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "bcc_for_answer"
    },
    domProps: {
      "checked": _vm.flow.bcc
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('flows.label.useBCC')) + "  "), _c('span', {
    staticClass: "glyphicon glyphicon-question-sign",
    attrs: {
      "id": "bcc-tooltip",
      "data-toggle": "tooltip",
      "title": _vm.$t('flows.label.emailBCCIntegration'),
      "data-placement": "right"
    }
  })])])]), _c('hr', {
    staticClass: "thick"
  }), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-gray",
    attrs: {
      "to": _vm.cancel_path
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('div', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "save"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.save_button_text))])], 1), _c('confirm-modal', {
    attrs: {
      "id": "confirm-save",
      "title": _vm.modal_title,
      "message": _vm.modal_message,
      "confirm_text": _vm.modal_confirm_text
    },
    on: {
      "confirm-modal-confirm": _vm.saveFlow
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4633d71a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/form.vue
// module id = 1095
// module chunks = 1